import { DefaultState } from '@src/redux/types'

import { VACATION_PUBLIC_INFO, VACATION_REQUEST_DOWNLOAD, VACATION_REQUEST_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [VACATION_REQUEST_LIST]: DefaultState<`${typeof API.VACATION_REQUEST}`, 'get'>
  [VACATION_REQUEST_DOWNLOAD]: DefaultState<`${typeof API.VACATION_REQUEST_DOWNLOAD}`, 'get'>
  [VACATION_PUBLIC_INFO]: DefaultState<`${typeof API.VACATION_PUBLIC_INFO}`, 'get'>
} = () => ({
  [VACATION_REQUEST_LIST]: defaultState(),
  [VACATION_REQUEST_DOWNLOAD]: defaultState(),
  [VACATION_PUBLIC_INFO]: defaultState(),
})
